import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { loginReset, loginSuccess } from "../redux/features/loginSlice";
import { userTokenAuthenticateAction } from "../services/actions/loginActions";
import { DefaultLayout } from "../layout/DefaultLayout";

export const PrivateRoute = ({ children, ...rest }) => {
	const dispatch = useDispatch();
	let location = useLocation();
	const navigate = useNavigate();
	const { isAuth } = useSelector(state => state.login);
	let from = location.state?.from?.pathname || location || "/";
	useEffect(() => {
		const verifyUserToken = async (userToken) => {
			const result = await dispatch(userTokenAuthenticateAction(userToken));
			if (result.status === 'Error') {
				dispatch(loginReset())
			} else {
				dispatch(loginSuccess({ userToken: result.data.userToken, userData: result.data.user, userBranchStore: result.data.user.userBranchStore }));
				navigate(from, { replace: true });
			}
		};
		// If in session Storage userToken is Already Present then verify the userToken
		!isAuth && localStorage.getItem("userToken") && verifyUserToken(localStorage.getItem("userToken"));

		//!isAuth && localStorage.getItem("userToken") && dispatch(loginSuccess());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		isAuth ? (
			<DefaultLayout>{children}</DefaultLayout>
		) : (
			<Navigate
				to={{
					pathname: "/login",
					state: { from: location },
				}}
			/>
		)
	);
};